// Share a list with coaches. The modal itself is components/share/ShareModal (handoff "2b"), shared with the
// single-athlete share; this keeps the list call site's props. reportSport / reportCount feed the preview.
import React, { useMemo } from 'react';
import ShareModal from '../components/share/ShareModal';
import { listSubject } from '../components/share/shareSubjects';
import './ShareReportModal.css';

export default function ShareReportModal({ reportId, reportCode, reportTitle, reportSport, reportCount, onClose }) {
  const subject = useMemo(
    () => listSubject({ id: reportId, code: reportCode, title: reportTitle, sport: reportSport, count: reportCount }),
    [reportId, reportCode, reportTitle, reportSport, reportCount],
  );
  return <ShareModal subject={subject} onClose={onClose} />;
}
